
export const clearStoreThunk = async (thunkAPI) => {
    try {
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    }
  };